import React, { useState, useEffect } from "react";
import BeatLoader from "react-spinners/BeatLoader";
import Chip from '@material-ui/core/Chip';
import swal from 'sweetalert'
import GridContainer from "components/Grid/GridContainer.js";
import GridItem from "components/Grid/GridItem.js";
import styles from "assets/jss/material-kit-react/views/learningPage.js";
import Axios from "axios";
import Config from "../../../../config.js"
import Card from '@material-ui/core/Card';
import CardActionArea from '@material-ui/core/CardActionArea';
import CardActions from '@material-ui/core/CardActions';
import CardContent from '@material-ui/core/CardContent';
import CardMedia from '@material-ui/core/CardMedia';
import TextField from '@material-ui/core/TextField';
import Typography from '@material-ui/core/Typography';
import Button from '@material-ui/core/Button';
import md5 from "md5";

// @material-ui/core components
import { makeStyles } from "@material-ui/core/styles";
import {
  useHistory
} from "react-router-dom";
const useStyles = makeStyles(styles);

export default function CertificateSample(props) {
  const classes = useStyles();

  return (
    <div className={classes.container}>
      <GridContainer justify="left" className={classes.box}>
        <GridItem className={classes.rightAlign} xs={12} sm={12} md={12}>
          <img src="#" className={classes.fullimage}/>
        </GridItem>

      </GridContainer>
      <div className={classes.description}>
        <p>
          {" "}
        </p>
      </div>
      <GridContainer justify="center">
      </GridContainer>
    </div>
  );
}





